
import axios from 'axios';

let url = 'https://extreme-ip-lookup.com/json/';

export const userLocation = async () => {
    try {
    const response = await axios.get(url);
    if (!response.data) return;
    return response.data;
    } catch(e) {
        console.log(e);
    };
  };



  export const getBrowser = () => {
    // Opera 8.0+
const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
const isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]" 
const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
const isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 71
const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);


let browser;

switch (true) {
    case isFirefox:
        browser = 'Firefox';
        break;
    case isChrome:
        browser = 'Chrome';
        break;
    case isSafari:
        browser = 'Safari';
        break;
    case isOpera:
        browser = 'Opera';
        break;
    case isIE:
        browser = 'IE';
        break;
    case isEdge:
        browser = 'Edge';
        break;
    default:
        browser = 'Unknown';
}
    return browser;
  };



export const getOS = () => {

    let OSName = "Unknown";
    
    if (window.navigator.userAgent.indexOf("Windows NT 10.0")!= -1) OSName="Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSName="Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSName="Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSName="Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSName="Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSName="Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac")            != -1) OSName="Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11")            != -1) OSName="UNIX";
    if (window.navigator.userAgent.indexOf("Linux")          != -1) OSName="Linux";
    
        return OSName;
      };
      
    